import { Link, NavLink } from 'react-router';
import { currentEmail, signOut } from '../auth';
import { useMe } from '../director/queries';
import { Logo } from './Logo';

/** Header for the pages outside a race: the race list and admin screens. */
export function TopBar() {
  const me = useMe();
  return (
    <header className="bar">
      <div className="bar-inner">
        <Link to="/" className="brand">
          <Logo />
          <span>Splitline</span>
        </Link>
        {me.data?.admin && (
          <nav aria-label="Primary" className="nav">
            <NavLink to="/" end>
              Races
            </NavLink>
            <NavLink to="/admin/directors">Directors</NavLink>
          </nav>
        )}
        <div className="bar-right">
          <Link to="/help" style={{ color: 'var(--bar-muted)' }}>
            Help
          </Link>
          <span>
            {currentEmail()}
            {me.data?.admin ? ' · admin' : ''}
          </span>
          <button
            type="button"
            className="btn link"
            style={{ color: 'var(--bar-muted)' }}
            onClick={() => {
              signOut();
              location.assign('/login');
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
